module.exports = __webpack_public_path__ + "img/10860_L.092589e9.png";